"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));

var _reactJsxHighcharts = require("react-jsx-highcharts");

var _strings = require("../Voting/strings");

var _propTypes = _interopRequireDefault(require("prop-types"));

function getMiddleValue(votes) {
  var totalVotes = votes.reduce(function (acc, cur) {
    return acc + cur;
  }, 0);
  var totalValues = votes.reduce(function (acc, cur, index) {
    return cur * index + acc;
  }, 0);
  return totalValues / totalVotes;
}

function LikertInvertedAreaChart(_ref) {
  var group = _ref.group,
      questions = _ref.questions,
      feedbacks = _ref.feedbacks;
  var middleValues = feedbacks.map(function (feedback, index) {
    var votes = questions[index].data.answers.map(function (a) {
      return feedback && feedback.hasOwnProperty(a.uuid) ? feedback["".concat(a.uuid, "_abs")] : 0;
    });
    var middleValue = getMiddleValue(votes);
    return Number(middleValue);
  });
  return /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.HighchartsChart, {
    type: "area"
  }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Chart, {
    inverted: true
  }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Title, null, "".concat((0, _strings.getString)('EVALUATION'), ": ").concat(group)), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.XAxis, {
    categories: questions.map(function (q) {
      return q.html;
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Tooltip, null), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis, {
    min: 0,
    max: questions[0].data.answers.length - 1,
    tickInterval: 1,
    allowDecimals: false
  }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.LineSeries, {
    name: (0, _strings.getString)('MIDDLEVALUE'),
    data: middleValues
  })));
}

(0, _highchartsMore["default"])(_highcharts["default"]);
LikertInvertedAreaChart.propTypes = {
  feedbacks: _propTypes["default"].array,
  questions: _propTypes["default"].array,
  group: _propTypes["default"].string
};

var _default = (0, _reactJsxHighcharts.withHighcharts)(LikertInvertedAreaChart, _highcharts["default"]);

exports["default"] = _default;